<div class="modal-body">
  <div class="content">
    <div class="content__main">
      <div class="top">
        <h4 translate>equipment.details.modals.change-outbound-did.title</h4>
        <button type="button" class="close" aria-label="Close" (click)="close()">
          <i class="icon-small-close"></i>
        </button>
      </div>
      <div *ngIf="isDidsListLoading">
        <ngx-skeleton-loader [theme]="{'height':'200px'}"></ngx-skeleton-loader>
      </div>
      <form>
        <div class="form-group" *ngIf="!isDidsListLoading && didsList.length > 0">
          <label for="company" translate>equipment.details.modals.change-outbound-did.label</label>
          <div ngbDropdown class="d-inline-block dropdown" placement="bottom">
            <button class="vox-btn dropdown_btn" id="assign-user-dropdown" ngbDropdownToggle>
              <span *ngIf="!selectedDid" translate>equipment.details.modals.change-outbound-did.no-current</span>
              <span *ngIf="selectedDid">{{selectedDid.number}}</span>
            </button>
            <div ngbDropdownMenu aria-labelledby="assign-user-dropdown">
              <button ngbDropdownItem class="dropdown__item" type="button" *ngFor="let did of didsList"
                (click)="onSelectDid(did)" translate>
                {{did.number}}
              </button>
            </div>
          </div>
        </div>
        <div class="form-group" *ngIf="!isDidsListLoading && didsList.length === 0">
          <p translate>Non ci sono DID associati a questo pbx. Aggiungi un DID prima di impostare l'outbound DID del
            dispositivo</p>
        </div>
        <div class="submit-container">
          <button class="vox-btn vox-btn-primary" type="submit"
            [disabled]="didsList.length === 0 || currentDid === selectedDid?.number" (click)="emitSave()">
            <span translate>equipment.details.modals.change-outbound-did.change</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>